import { render, staticRenderFns } from "./local-invoice.vue?vue&type=template&id=43a8bec9&"
import script from "./local-invoice.vue?vue&type=script&lang=js&"
export * from "./local-invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports